<template>
  <section>
    <div class="row">
      <div class="col title">Submission</div>
      <!--Mobile Only-->
      <div class="col-3 pl-1 hidden-md-up">
        <for-authors-mobile-menu :anchors-list="anchorsList"></for-authors-mobile-menu>
      </div>
      <!--Mobile Only-->
    </div>

    <div>
      <p>
        All submissions must be made electronically through the online submission system (<a :href="`http://${site}.msubmit.net/cgi-bin/main.plex`" target="_blank">http://{{site}}.msubmit.net/cgi-bin/main.plex</a>).
        Before you submit a manuscript, be sure to read all the {{siteName}} Instructions for Authors/Editorial and Publishing Policies.
      </p>
      <p>
        You will find complete details on how to submit a manuscript when you log on to online submission system to create an author account.
      </p>
    </div>
  </section>
</template>

<script>
  import ForAuthorsMobileMenu from '@/components/for-authors/ForAuthorsPageMobileMenu'
  export default {
    name: 'for-authors-submission-content',
    components: {ForAuthorsMobileMenu},
    props: ['anchorsList'],
    data () {
      return {
        siteName: process.env.SITE_NAME,
        site: process.env.SITE
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ForAuthorsSubmissionContent.vue?1bf1e198